<template>
  <div class="page--third_party_conf">
    <!-- popup -->
    <Popup class="create-popup" ref="create_popup">
      <div class="content-inner-wrap">
        <div class="field">
          <div class="label">{{ $t("field.third_party_conf.key_name") }}</div>
          <input v-model="newObj.key_name"/>
        </div>
        <div class="action">
          <div class="confirm button" @click="create">{{ $t("button.confirm") }}</div>
        </div>
      </div>
    </Popup>
    <Popup class="delete-popup" ref="delete_popup">
      <div class="content-inner-wrap">
        <div class="content">{{ $tc("message.confirm_to_remove_app_secret",null,{ id: selected.app_serect.id, key_name: selected.app_serect.key_name }) }}</div>
        <div class="action">
          <div class="confirm button" @click="remove">{{ $t("button.confirm") }}</div>
        </div>
      </div>
    </Popup>
    <!-- end of popup -->
    <div class="inner-wrap">
      <div class="wrapper app-secret">
        <div class="table" :class="{ 'dirty': dirty.app_serect }">
          <div class="head">
            <div class="field" :class="f" v-for="f in app_conf_fields" :key="f" :style="`width:${field_width[f]}px;`">{{ tran("third_party_conf", f) }}</div>
            <div class="field" :style="`width:50px;`"></div>
          </div>
          <div class="body">
            <div class="row" :class="{ 'selected': selected.app_serect.id == r.id }" v-for="r in rows" :key="r.id" @click="selectAppSecret(r)">
              <div class="field" :class="f" v-for="f in app_conf_fields" :key="f" :style="`width:${field_width[f]}px;`">{{ r[f] }}</div>
              <div class="button delete-btn" :style="`width:50px;`" :class="{ 'show': dirty && selected.app_serect.id == r.id }" @click="deleteSecret">
                <fa :icon="['fas','trash']" size="lg"/>
              </div>
            </div>
          </div>
        </div>
        <div class="button add-new" @click="clickedCreate">
          <fa :icon="['fas','plus']" size="lg"/>
        </div>
      </div>
      <div class="divider"></div>
      <div class="wrapper privilege">
        <div class="table" v-if="selected.app_serect.id" :key="selected.app_serect.id">
          <div class="head">
            <div class="field">{{ tran("third_party_conf", "privilege_key") }}</div>
            <div class="field" style="width:50px;">{{ tran("third_party_conf", "assigned") }}</div>
          </div>
          <div class="body">
            <div class="row" v-for="(p,i) in privileges[selected.app_serect.id]" :key="i" @click="toggleAssigned(i)">
              <div class="field">{{ p.privilege_key }}</div>
              <div class="field" style="width:50px;">
                <input type="checkbox" v-model="p.assigned"/>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
    <div class="action">
      <div class="button save-btn" @click="save">{{ $t("button.save") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  async beforeMount() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.rows = (await this.$axios.get("/app_secrets"))?.data?.response?.dataset || [];
    },
    async selectAppSecret(obj) {
      this.privileges[obj.id] = (await this.$axios.get(`/privileges_by_app/${obj.app_id}`)).data;
      this.selected.app_serect = obj;
      this.dirty.app_serect = true;
    },
    toggleAssigned(i) {
      this.privileges[this.selected.app_serect.id][i].assigned = !this.privileges[this.selected.app_serect.id][i].assigned;
      this.$forceUpdate();
    },
    clickedCreate() {
      this.$refs.create_popup.show();
    },
    async create() {
      await this.$axios.post(`/app_secrets`, this.newObj);
      this.newObj = {};
      this.$refs.create_popup.close();
      this.fetchData();
    },
    async save() {
      let id = this.selected.app_serect.id;
      await this.$axios.post(`/app_secrets/privilege/${id}`, this.privileges[id]);
      this.$message({
        message: this.$t("message.save_successfully"),
        type: 'success'
      });
    },
    deleteSecret() {
      this.$refs.delete_popup.show();
    },
    async remove() {
      this.$store.commit("control/setLoad", true);
      await this.$axios.delete(`/app_secrets/${this.selected.app_serect.id}`);
      this.$store.commit("control/setLoad", false);
      this.$refs.delete_popup.close();
      this.fetchData();
    }
  },
  data() {
    return {
      app_conf_fields: ["id","key_name","app_id","api_key"],
      privilege_fields: ["privilege_key","assigned"],
      field_width: {
        id: 50,
        key_name: 100,
        app_id: 130
      },
      rows: [],
      newObj: {},
      privileges: {},
      selected: {
        app_serect: {}
      },
      dirty: {
        app_serect: false
      }
    }
  }
}
</script>

<style lang="scss">
.page--third_party_conf{
  height: 100%;
  &>.inner-wrap{
    display: flex;
    gap: 30px;
    height: calc(100% - 35px);
    .wrapper{
      display: flex;
      gap: 15px;
      &.app-secret{
        flex-grow: 1;
        .row{
          transition: background .2s linear, opacity .2s linear;
        }
      }
      &.privilege{
        width: 300px;
      }
    }
  }
  .table{
    flex-grow: 1;
    overflow-y: auto;
    &.dirty{
      .row{
        opacity: .3;
      }
    }
  }
  .privilege-wrapper{
    // width: 600px;
    height: 200px;
  }
  .table{
    font-size: 12px;
    .row,
    .head{
      display: flex;
      align-items: center;
      .field{
        flex-grow: 1;
        width: 100%;
        height: 30px;
      }
    }
    .field{
      padding: 0 5px;
      display: flex;
      align-items: center;
    }
    .head{
      background-color: #ededed;
      font-weight: bold;
    }
    .row{
      cursor: pointer;
      transition: background .2s linear;
      
      &.selected{
        background: #e2e2e2;
        opacity: 1!important;
      }
      &:not(:last-child) {
        // border-bottom: 1px solid rgba(0,0,0,.2);
      }
      &:not(.selected):hover{
        background: #f5f5f5;
      }
    }
  }
  .action{
    display: flex;
    justify-content: flex-end;
  }
  .add-new{
    height: 30px!important;
    width: 30px!important;
    background: royalblue!important;
  }
  .save-btn{
    background: royalblue!important;
    color: white;
    width: 125px!important;
  }
  .button{
    height: 35px;
    width: 35px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #999;
    cursor: pointer;
    color: white;
  }
  .button.save-btn{
    background: royalblue;
  }
  .button.confirm{
    background: royalblue;
    width: 125px!important;
  }
  .button.delete-btn{
    background: red;
    height: 30px;
    width: 30px;
    visibility: hidden;
    &.show{
      visibility: visible;
    }
  }
  .divider{
    width: 2px;
    background: #999;
    margin: 40px 0;
    opacity: .2;
  }

  // popup
  .create-popup{
    .popup-content{
      width: 400px;
      height: 150px;
      background: white;
      .content-inner-wrap{
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        padding: 0 30px;
        .field{
          display: flex;
          flex-direction: column;
          margin-bottom: 10px;
          .label{
            font-size: 14px;
          }
          input{
            height: 30px;
            flex-grow: 1;
          }
        }
      }
    }
  }
  //
  .delete-popup{
    .popup-content{
      width: 400px;
      height: 100px;
      background: white;
      .content-inner-wrap{
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        .content{
          flex-grow: 1;
          display: flex;
          justify-content: center;
          padding-top: 20px;
        }
        .action{
          padding: 5px 30px;
          display: flex;
          justify-content: center;
          .button.confirm{
            background: red;
          }
        }
      }
    }
  }
}
</style>